export const titles = {
  Mr: 'Mr',
  Mrs: 'Mrs',
  Ms: 'Ms',
  Miss: 'Miss',
  Dr: 'Dr',
  Pastor: 'Pastor',
  Rev: 'Reverend',
  ADM: 'Admiral',
  AMN: 'Airman',
  AB: 'Airman Basic',
  A1C: 'Airman First Class',
  BG: 'Brigadier General',
  Cadet: 'Cadet',
  CPT: 'Captain (ARMY, USAF, USMC)',
  CAPT: 'Captain (NAVY, USCG)',
  Chaplain: 'Chaplain',
  'CH MAJ': 'Chaplain Major',
  CMSgt: 'Chief Master Sergeant (USAF)',
  CPO: 'Chief Petty Officer',
  CWO: 'Chief Warrant Officer',
  CWO2: 'Chief Warrant Officer 2',
  CWO3: 'Chief Warrant Officer 3',
  CWO4: 'Chief Warrant Officer 4',
  CWO5: 'Chief Warrant Officer 5',
  COL: 'Colonel',
  CCM: 'Command Chief Master Sergeant (USAF)',
  CMC: 'Command Master Chief (USCG)',
  CSM: 'Command Sergeant Major (ARMY)',
  CDR: 'Commander',
  CPL: 'Corporal (ARMY)',
  Cpl: 'Corporal (USMC)',
  ENS: 'Ensign',
  '1LT': 'First Lieutenant',
  '1SG': 'First Sergeant (ARMY)',
  '1st Sgt': 'First Sergeant (USMC)',
  'E-7': 'First Sergeant E-7 (USAF)',
  'E-8': 'First Sergeant E-8 (USAF)',
  'E-9': 'First Sergeant E-9 (USAF)',
  FLTMC: 'Fleet Command Master Chief Petty Officer (NAVY)',
  FORMC: 'Force Command Master Chief Petty Officer (NAVY)',
  GEN: 'General',
  GySgt: 'Gunnery Sergeant (USMC)',
  LCpl: 'Lance Corporal (USMC)',
  LT: 'Lieutenant (NAVY, USCG)',
  LTC: 'Lieutenant Colonel',
  LCDR: 'Lieutenant Commander',
  LTG: 'Lieutenant General',
  'LTG(R)': 'Lieutenant General (Retired)',
  LTJG: 'Lieutenant Junior Grade',
  MAJ: 'Major',
  MG: 'Major General',
  MCPO: 'Master Chief Petty Officer',
  MGySgt: 'Master Gunnery Sergeant (USMC)',
  MSG: 'Master Sergeant (ARMY)',
  MSgt: 'Master Sergeant (USMC, USAF)',
  PO1: 'Petty Officer First Class',
  PO2: 'Petty Officer Second Class',
  PO3: 'Petty Officer Third Class',
  Pvt: 'Private (USMC)',
  PV1: 'Private E-1 (ARMY)',
  PV2: 'Private E-2 (ARMY)',
  PFC: 'Private First Class (ARMY, USMC)',
  'RADM(L)': 'Rear Admiral (Lower Half)',
  'RADM(U)': 'Rear Admiral (Upper Half)',
  SN: 'Seaman',
  SA: 'Seaman Apprentice',
  SR: 'Seaman Recruit',
  '2LT': 'Second Lieutenant',
  SrA: 'Senior Airman',
  SCPO: 'Senior Chief Petty Officer',
  SMSgt: 'Senior Master Sergeant (USAF)',
  SGT: 'Sergeant (ARMY)',
  Sgt: 'Sergeant (USMC)',
  SFC: 'Sergeant First Class (ARMY)',
  SGM: 'Sergeant Major (ARMY)',
  'Sgt Maj': 'Sergeant Major (USMC)',
  SPC: 'Specialist (ARMY)',
  SSG: 'Staff Sergeant (ARMY)',
  SSgt: 'Staff Sergeant (USMC, USAF)',
  TSgt: 'Technical Sergeant (USAF)',
  VADM: 'Vice Admiral',
  WO1: 'Warrant Officer (ARMY)',
  WO: 'Warrant Officer (USMC)',
  Ambassador: 'Ambassador',
  Bishop: 'Bishop',
  Brother: 'Brother',
  Dcn: 'Deacon',
  Father: 'Father',
  Gov: 'Governor',
  HM: 'Headmaster',
  Honorable: 'Honorable',
  Judge: 'Judge',
  'Lt Gov': 'Lieutenant Governor',
  Mdm: 'Madam',
  Mayor: 'Mayor',
  'Prof.': 'Professor',
  Rabbi: 'Rabbi',
  Representative: 'Representative',
  'Rev Dr': 'Reverend Doctor',
  Senator: 'Senator',
  Sister: 'Sister',
};

export const legacyTitles = {
  Alderman: 'Alderman',
  Alderwoman: 'Alderwoman',
  Madam: 'Ambassador (Madam)',
  Sir: 'Ambassador (Sir)',
  Assemblyman: 'Assemblyman',
  Assemblywoman: 'Assemblywoman',
  'Brig Gen': 'Brigadier General (USAF,USMC)',
  Capt: 'Captain (USAF,USMC)',
  Col: 'Colonel (USAF,USMC)',
  Councilman: 'Councilman',
  Councilwoman: 'Councilwoman',
  '1st Lt': 'First Lieutenant (USAF,USMC)',
  Gen: 'General (USAF,USMC)',
  'H.E.': 'His Excellency',
  'Lt Col': 'Lieutenant Colonel (USAF,USMC)',
  'Lt Gen': 'Lieutenant General (USAF,USMC)',
  Maj: 'Major (USAF,USMC)',
  'Maj Gen': 'Major General (USAF,USMC)',
  Master: 'Master',
  SgtMajMC: 'Master Sergeant MC',
  PO: 'Petty Officer',
  PVT: 'Private (ARMY)',
  Prof: 'Professor',
  RADM: 'Rear Admiral (NAVY,USCG)',
  '2nd Lt': 'Second Lieutenant (USAF,USMC)',
  Supervisor: 'Supervisor',
};
